import styled from 'styled-components';
import { IconButton } from 'modules/v2/navigation/buttons';
export const StyledIconButton = styled(IconButton) `
  padding: 0;
  margin: 0;
`;
